export default "__VITE_ASSET__DrnDBalU__"